import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TryoutMember } from '../../interfaces/tryout_interface/tryout-member';
import { TryoutMemberCount } from '../../interfaces/tryout_interface/tryout-member-count';
import { TryoutMemberSearch } from '../../interfaces/tryout_interface/tryout-member-search';
import { UserInfo } from '../../interfaces/tryout_interface/user-info';
import { HttpService } from '../http.service';
import { StorageUtil, map } from '../../store';

@Injectable()
export class TryoutMemberService {
  private _url = '/api/ClubUserProgramFee';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  getTryoutMemberCounts(id: string, userID: number): Observable<TryoutMemberCount> {
    return this.httpService.get(this._url + '/get-tryout-members-count/' + id, { params: { userID } } );
  }

  getTryoutMembers(id: string, status: string): Observable<TryoutMember[]> {
    return this.httpService.get(this._url + '/tryoutprogram/' + id + '/' + status, { params: { userID: StorageUtil.userID } })
      .pipe(map(members => members.map(m => ({
        ...m,
        // birthYear: Math.max(0, new Date().getFullYear() - m.age),
        birthYear: new Date(m.dob).getFullYear(),
        invitedTeams: m.invitedTeams ? m.invitedTeams.split(',').map(s => +s) : []
      }))));
  }

  getAllTryoutMembers(id: string): Observable<TryoutMember[]> {
    return this.httpService.get(this._url + '/tryoutprogram/' + id + '/0', { params: { userID: StorageUtil.userID } })
      .pipe(map(members => members.map(m => ({
        ...m,
        // birthYear: Math.max(0, new Date().getFullYear() - m.age),
        birthYear: new Date(m.dob).getFullYear(),
        invitedTeams: m.invitedTeams ? m.invitedTeams.split(',').map(s => +s) : []
      }))));
  }

  getMemberInfo(UserID: string, ClubProgramID: string): Observable<UserInfo[]> {
    return this.http.get<UserInfo[]>(this._url + '/tryout-user-info/' + UserID + '/' + ClubProgramID);
  }

  getTryoutFees(UserID: string, ClubProgramID: string): Observable<UserInfo[]> {
    return this.http.get<UserInfo[]>(this._url + '/tryout-user-fees/' + UserID + '/' + ClubProgramID);
  }

  getTryoutMemberBySearch(tryoutMemberSearch: TryoutMemberSearch) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/tryoutusersearch/', tryoutMemberSearch, httpOptions);
  }

  assignMembersToTeams(users: number[], teams: number[]) {
    return this.httpService.post(`${this._url}/assign-users-to-teams`, { users, teams, clubAdminID: +StorageUtil.userID });
  }

  getAnswers(clubProgramId: number) {
    return this.httpService.get(`${this._url}/get-tryout-members-questions-answers/${clubProgramId}`);
  }
  
  getClubProgramQuestionsAndAnswersByClubProgramID(clubProgramID: number) {
    return this.httpService.get(`${this._url}/get-club-program-questions-and-answers-by-clubProgramID/${clubProgramID}`);
  }

  deleteFee(id: number) {
    return this.httpService.delete(`${this._url}/delete-members/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tryout_Services/tryout-member.service.ts